import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { FormControl, Button, TextField } from '@material-ui/core';
import { Header } from './components';
import { createStyles } from '@material-ui/core/styles';
import SendIcon from '@material-ui/icons/Send';


const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
        width: 200
      },
    },
  }),
);

const Contact = () => {
  window.scrollTo(0, 0)
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Header />
      <div className={classes.content} style={{ background: '#FFF', textAlign: 'center', paddingTop: '8vh', paddingBottom: '5vh' }}>
        <FormControl >
          <span style={{ color: '#F00', fontSize: 10 }}>Form currently unavailable! :(</span>
          <TextField disabled style={{ width: '60vw' }} id="name" label="Name" variant="outlined" />
          <TextField disabled style={{ width: '60vw' }} id="email" label="Email" variant="outlined" />
          <TextField disabled
            style={{ width: '60vw' }}
            id="message"
            label="Enter you message"
            multiline
            rows="4"
            variant="outlined"
          />
          <Button disabled
            variant="contained"
            style={{ marginTop: '4vh', color: "#FCFCFC", background: "#84a086" }}
            startIcon={<SendIcon />}
          >
            Send
            </Button>
        </FormControl>
      </div>
    </div>
  );
};


export default Contact;